const UNIT_TO_MS = {
    days: 1000 * 60 * 60 * 24,
    hours: 1000 * 60 * 60,
    minutes: 1000 * 60,
    seconds: 1000,
};

class mCountdown extends HTMLDivElement {
    static observedAttributes = ['data-end-date'];

    constructor() {
        super();
        this.endDate = new Date();
        this.intervalID = null;
        this.i18n = {};
    }

    connectedCallback() {
        this.querySelectorAll('[data-unit]').forEach((el) => {
            const unit = el.getAttribute('data-unit');
            const i18nLabel = el.getAttribute('data-i18n-label');
            if (i18nLabel) {
                this.i18n[unit] = i18nLabel;
            }
        });
        this.updateCountdown();
        this.intervalID = setInterval(this.updateCountdown.bind(this), 1000);
    }

    disconnectedCallback() {
        clearInterval(this.intervalID);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'data-end-date':
                this.endDate = new Date(newValue);
                break;
            default:
                break;
        }
    }

    updateUnit(unit, remainingInMs) {
        const unitInMs = UNIT_TO_MS[unit];
        const newNb = Math.floor(remainingInMs / unitInMs);
        const colEl = this.querySelector(`[data-unit="${unit}"]`);
        if (colEl && this.i18n[unit]) {
            colEl.setAttribute('aria-label', this.i18n[unit].replace('{0}', newNb));
        }
        const nbEl = colEl?.querySelector('.number');
        if (nbEl) {
            nbEl.textContent = String(newNb).padStart(2, '0');
        }
        return remainingInMs % unitInMs;
    }

    updateCountdown() {
        const now = Date.now();
        let distance = Math.max(0, this.endDate.getTime() - now);
        distance = this.updateUnit('days', distance);
        distance = this.updateUnit('hours', distance);
        distance = this.updateUnit('minutes', distance);
        this.updateUnit('seconds', distance);
    }
}

customElements.define('m-countdown', mCountdown, { extends: 'div' });
